import type { RootState } from "../types/store.types";

export const selectSelectedBuilderTab = (state: RootState) => state.uiSettings.builderSelectedTab;
export const selectVersionHistoryOpen = (state: RootState) => state.uiSettings.versionHistoryOpen;
export const selectEditDisabled = (state: RootState) => state.uiSettings.editDisabled;
